
const ipaddress ='www.dgdcseepz.in:8443/DGDC/';

// const ipaddress ='103.189.88.215:8085/';

export default ipaddress;